import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common';
import { HandlingUnitNotificationsState } from './handling-unit-notifications.state';
import { MonitoringNotificationsModel } from '../../../../models/monitoring-notification';
import {
  HandlingUnitNotificationsInitialState,
  HandlingUnitNotificationsLoad,
} from './handling-unit-notifications.actions';

@Injectable({ providedIn: 'root' })
export class HandlingUnitNotificationsFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(HandlingUnitNotificationsState.getLoaded);
  notifications$: Observable<MonitoringNotificationsModel[]> = this.store.select(
    HandlingUnitNotificationsState.getNotifications,
  );

  constructor(private store: Store) {}

  loadAll(itemNumbers: { deliveryNoteNumber: string; handlingUnitNumber: string }): void {
    this.store.dispatch(new HandlingUnitNotificationsLoad(itemNumbers));
  }

  setInitialState(): void {
    this.store.dispatch(new HandlingUnitNotificationsInitialState());
  }
}
